import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApisService } from './apis.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  public smsList: Array<any> = []
  constructor(
    private apis: ApisService,
    private http: HttpClient
  ) { }

  fnGetSmsSettings() {
    let payload: any = { search: { value: "sms" } };
    this.http.post<any>(this.apis.smsSettings, payload)
    .subscribe(resp=>{
      this.smsList = resp.data;
    })
  }
}
